import styled from "styled-components";
import { BoxShadowWithHover } from "../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
export const BenefitsCardWrapper = styled.div.withConfig({
    displayName: "styled__BenefitsCardWrapper",
    componentId: "sc-27ef98d6-0"
})`
	${BorderRadius({
    all: '4px'
})};
	${FlexMixin({
    direction: 'column',
    align: 'center'
})};
	background-color: ${({ theme  })=>theme.colors.primary.light};
	margin-bottom: 18px;
	margin-top: 4px;
	max-height: 100%;
	min-width: 300px;
	max-width: 320px;
	${BoxShadowWithHover}

	&.is-tablet {
		${FlexMixin({
    direction: 'row',
    justify: 'space-between'
})};
		margin-top: 0;
		max-height: unset;
		min-width: unset;
		max-width: unset;
		height: auto;
		min-height: 84px;
		width: calc(100% - 4px);
		margin-left: 2px;
		column-gap: 40px;
	}
`;
export const BenefitsCardTitle = styled.div.withConfig({
    displayName: "styled__BenefitsCardTitle",
    componentId: "sc-27ef98d6-1"
})`
	background-color: ${({ theme  })=>theme.colors.primary.base};
	color: ${({ theme  })=>theme.colors.white.base};
	font-family: ${({ theme  })=>theme.font.family.secondary};
	${FontMixin({
    size: 'largest',
    weight: 'regular',
    height: 'largest'
})};
	${FlexMixin({
    justify: 'center',
    direction: 'column',
    align: 'center'
})};
	margin-bottom: 40px;
	min-width: 100%;
	padding: 20px;
	z-index: 10;
	${BorderRadius({
    all: '4px'
})}
	position: relative;
	text-align: center;
	margin-bottom: 40px;
	min-width: 100%;

	::after {
		background-color: ${({ theme  })=>theme.colors.primary.base};
		bottom: -15px;
		content: '';
		height: 20%;
		position: absolute;
		right: 0;
		transform: skewY(-5deg);
		width: 100%;
		z-index: 0;
	}

	&.is-tablet {
		${({ theme  })=>`font-family: ${theme.font.family.primary};`};
		${FontMixin({
    size: 'large',
    weight: 'medium'
})};
		line-height: 26px;
		${FlexMixin({
    justify: 'center',
    direction: 'row',
    align: 'center'
})};
		z-index: 1;
		padding: 0;
		margin-bottom: 0;
		min-width: unset;
		width: 30%;
		height: 84px;

		::before {
			${({ theme  })=>`background-color: ${theme.colors.primary.base};`};
			height: 100%;
			width: 18px;
			content: '';
			right: -8px;
			position: absolute;
			transform: skew(-13deg);
			z-index: -1;
		}

		::after {
			content: none;
		}

		span {
			text-align: start;
			margin-left: 12px;
		}

		.nico-circle-check {
			margin-left: 16px;
			&:before {
				display: inline-block;
				font-size: 36px;
				color: white;
			}
		}
	}
`;
export const Items = styled.div.withConfig({
    displayName: "styled__Items",
    componentId: "sc-27ef98d6-2"
})`
	width: 50%;
	${FlexMixin({
    align: 'flex-start'
})};
`;
export const Content = styled.div.withConfig({
    displayName: "styled__Content",
    componentId: "sc-27ef98d6-3"
})`
	padding: 20px 16px;

	.nico-check {
		margin-right: 10px;
		&:before {
			display: inline-block;
			color: white;
			font-size: 11px;
		}
	}

	& span {
		color: ${({ theme  })=>theme.colors.white.base};
		${FlexMixin({
    justify: 'center'
})};
		${FontMixin({
    size: 'base',
    height: 'small',
    weight: 'light'
})};
		margin-bottom: 0;
		position: relative;
		padding: 20px 16px;
		&:not(:last-child)::after {
			${FlexMixin({
    justify: 'center'
})}
			border-bottom: 1px solid ${({ theme  })=>theme.colors.white.base};
			bottom: 0;
			content: '';
			position: absolute;
			width: 30px;
		}
	}

	&.is-tablet {
		${FlexMixin({
    direction: 'row',
    align: 'center',
    justify: 'center',
    wrap: true
})};
		width: 70%;
		margin-bottom: 0;
		padding: 0;

		span {
			${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'medium'
})};
			padding: 0;
		}
	}
`;

//# sourceMappingURL=styled.js.map